export default __webpack_public_path__ + "static/media/lesley.19fdfefe.png";